import { useFormikContext } from 'formik';
import { NumberField } from 'Shared/form/NumberField';
import PropTypes from 'prop-types';
import React from 'react';
import CommonPatientFieldWrapper from 'App/components/PatientForm/components/CommonPatientFieldWrapper';

const propTypes = {
    row: PropTypes.shape({
        id: PropTypes.string.isRequired,
    }).isRequired,
};

const defaultProps = {};

function CopayPercentCell({ row }) {
    const {
        values: { disableInputs },
    } = useFormikContext();
    return (
        <CommonPatientFieldWrapper fieldName="referralBiCoinsuranceAmt">
            {(commonProps) => (
                <NumberField
                    {...commonProps}
                    fieldName={`medications[${row.id}].data.copayPercent`}
                    disabled={disableInputs || commonProps.disabled}
                    placeholder="Coinsurance Amount"
                    min={0}
                    prefixAddon="%"
                />
            )}
        </CommonPatientFieldWrapper>
    );
}

CopayPercentCell.propTypes = propTypes;
CopayPercentCell.defaultProps = defaultProps;

export default CopayPercentCell;
